import { vservice } from '@niknevis/vue-modules'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { ContentItemSendToReviewRequestModel } from '@/modules/content-item/models/content-item-request.model'

@vservice()
export class AdminContentItemSendToReviewUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(campaignId: number, data: Omit<ContentItemSendToReviewRequestModel, 'status'>) {
    return this.service.sendToReview(campaignId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
